module.exports = __webpack_public_path__ + "static/media/slotsRouletteOut.966fe093.png";